import { render } from "./ArchivedAds.vue?vue&type=template&id=2ca0008c&scoped=true"
import script from "./ArchivedAds.vue?vue&type=script&lang=js"
export * from "./ArchivedAds.vue?vue&type=script&lang=js"

import "./ArchivedAds.vue?vue&type=style&index=0&id=2ca0008c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca0008c"]])

export default __exports__